$ = jQuery;
$(document).ready(function($) {
    $('#actuality').on('change', function(){
        var category = $(this).val();
        if(category === 'all'){
            $('.article-listing').removeClass('hide');
        } else {
            $('.article-listing').addClass('hide');
            $('.article-listing[data-category="'+category+'"]').removeClass('hide');
        }
    });
});